import React from "react";

const AutomatedMessageTag = ({ title = "Automated Message", classes = [] }) => (
  <p
    className={[
      `automated-message-tag automated-message-tag--${title
        .toLocaleLowerCase()
        .replace(/\s/g, "-")}`,
      ...classes,
    ].join(" ")}
  >
    {title}
  </p>
);

export default AutomatedMessageTag;
